<template>
  <div
    class="order-menu-empty-pack"
  >
    <img
      src="@/assets/images/newOrder/empty-pack.svg"
      alt=""
      height="77"
      class="order-menu-empty-pack__img"
    >
    <p class="order-menu-empty-pack__text order-menu-empty-pack__text--bold">
      Меню не надоест
    </p>
    <p class="order-menu-empty-pack__text">
      Четыре недели без повторов блюд
    </p>
  </div>
</template>

<script>
export default {
  name: 'EmptyPack',
}
</script>

<style lang="scss">
.order-menu-empty-pack {
  padding: 32px 16px 0;

  &__img {
    height: 77px;
    object-fit: contain;
    margin-bottom: 20px;
  }

  &__text {
    text-align: center;
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 2px;

    &--bold {
      font-weight: 600;
    }
  }
}
</style>
